var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-snackbar',_vm._g(_vm._b({attrs:{"value":_vm.value,"color":_vm.color,"timeout":_vm.timeout,"top":_vm.top,"bottom":_vm.bottom,"left":_vm.left,"right":_vm.right}},'v-snackbar',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }